import { render, staticRenderFns } from "./FormAreaKoordinator.vue?vue&type=template&id=c3a575d6&scoped=true"
import script from "./FormAreaKoordinator.vue?vue&type=script&lang=js"
export * from "./FormAreaKoordinator.vue?vue&type=script&lang=js"
import style0 from "./FormAreaKoordinator.vue?vue&type=style&index=0&id=c3a575d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a575d6",
  null
  
)

export default component.exports